import type { AppHeaderApp } from "./types";

/**
 * Conteúdo padrão do header. Ao contrário do `AppFooter`, o header **não tem
 * conteúdo de tenant** — nada aqui é dado da CUB como empresa. O que existe é
 * o nome de cada aplicação, que descreve o produto e por isso vale nos dois
 * tenants: o parceiro white label também está olhando a "Área do Cliente".
 *
 * Título e nome da company são as únicas strings do componente; company name e
 * logo vêm sempre da aplicação, porque são dados da operação em exibição.
 */

/**
 * Nome de cada aplicação, exatamente como na spec (`<headerStatementViewer>`,
 * node 3873:10314). Note as minúsculas em "cobranças" e em "dados" — é o que
 * está no Figma; se o certo for outra grafia, muda aqui e em nenhum outro
 * lugar.
 */
export const APP_HEADER_TITLES: Record<AppHeaderApp, string> = {
  "statement-viewer": "Área do Cliente",
  "billing-viewer": "Visualizador de cobranças",
  "onboarding-app": "Revisão de dados",
};

/** Rótulos fixos da interface. */
export const LABELS = {
  back: "Voltar",
} as const;
